import { IHisInfoItemBehavior } from "./IHisInfoItemBehavior";
import { HisInformationItem } from "../..";
import { IHisInformationValue, HisInformationTextValue, HisInformationDateTimeValue } from "../../HisInformationValue";
import { DefaultDateBehavior } from "./DefaultDateBehavior";
import { DefaultTimeBehavior } from "./DefaultTimeBehavior";
import { DateTimeStringUtility } from "../../../system/DateTimeStringUtility";

/** HIS項目手術経過時間(手術情報)を生成する */
export class OpePeriodBehavior implements IHisInfoItemBehavior {
  private static readonly Key = "OPE_PERIOD";
  private static readonly OpeStartDateKey = "OPE_START_DATE";
  private static readonly OpeStartTimeKey = "OPE_START_TIME";
  private static readonly OpeEndDateKey = "OPE_END_DATE";
  private static readonly OpeEndTimeKey = "OPE_END_TIME";
  
  getValue(hisInfoItems: HisInformationItem[]): IHisInformationValue {
    const itemValues =  hisInfoItems.filter(x => x.name === OpePeriodBehavior.Key).map(x => x.value);
    const startDateBehavior = new DefaultDateBehavior(OpePeriodBehavior.OpeStartDateKey);
    const startTimeBehavior = new DefaultTimeBehavior(OpePeriodBehavior.OpeStartTimeKey);
    const endDateBehavior = new DefaultDateBehavior(OpePeriodBehavior.OpeEndDateKey);
    const endTimeBehavior = new DefaultTimeBehavior(OpePeriodBehavior.OpeEndTimeKey);
    const startDateTime = createDateTime(hisInfoItems, startDateBehavior, startTimeBehavior);
    const endDateTime = createDateTime(hisInfoItems, endDateBehavior, endTimeBehavior);
    const values = (startDateTime.length === endDateTime.length)
      ? startDateTime.map((x, i) => formatOpePeriod(x, endDateTime[i]))
      : [];
    const data = itemValues.length > 0 ? itemValues : values;
    return new HisInformationTextValue(OpePeriodBehavior.Key, data);
  }
}

function createDateTime(items: HisInformationItem[], dateBehavior: IHisInfoItemBehavior, timeBehavior: IHisInfoItemBehavior): Date[] {
  const dateValue = dateBehavior.getValue(items);
  const timeValue = timeBehavior.getValue(items);
  const dates
    = (dateValue instanceof HisInformationDateTimeValue && timeValue instanceof HisInformationDateTimeValue)
    ? dateValue.data.map((x, i) => DateTimeStringUtility.convertToDateTime(x, timeValue.data[i]))
    : [];
  return dates;
}

/** 開始日時と終了日時の間の時間を返す。 */
function differenceHours(start: Date, end: Date): number {
  if (start > end) { throw new Error("argument error: 第1引数は第2引数と同日かそれ以前の日付でなければなりません。"); }
  
  const times = end.getTime() - start.getTime();
  const hours = Math.floor(times / (1000 * 60 * 60));
  return hours;
}

/** 開始日時と終了日時の間から時間を差し引いた分を返す。 */
function differenceMinutesSubtractHours(start: Date, end: Date): number {
  if (start > end) { throw new Error("argument error: 第1引数は第2引数と同日かそれ以前の日付でなければなりません。"); }
  
  const times = end.getTime() - start.getTime();
  const minutes = Math.floor(times / (1000 * 60));
  const minutesSubtractHours = minutes % 60;
  return minutesSubtractHours;
}

function formatOpePeriod(start: Date, end: Date): string {
  if (start > end) { throw new Error("argument error: 第1引数は第2引数と同日かそれ以前の日付でなければなりません。"); }

  const diffHours = differenceHours(start, end);
  const diffMinutes = differenceMinutesSubtractHours(start, end);
  return diffHours + "時間" + diffMinutes + "分";
}
